import { useState } from 'react'

export const useDisclouser = () => {
  const [isOpen, setIsOpen] = useState(false)
  const onOpen = () => setIsOpen(true)
  const onClose = () => setIsOpen(false)
  const onToggle = () => setIsOpen(open => !open)

  return { isOpen, onOpen, onClose, onToggle }
}
